import {
  SET_CONTRACTS_LIST,
  SET_CONTRACTS_VIEW,
  UPDATE_CONTRACTS_LIST
} from "../../constants/actionTypes";

export const setContractsView = (contractsView) => ({
  type: SET_CONTRACTS_VIEW,
  payload: {contractsView}
});

export const setContractsList = (contractsList) => ({
  type: SET_CONTRACTS_LIST,
  payload: {contractsList}
});

export const updateContractsList = (contractsList) => ({
  type: UPDATE_CONTRACTS_LIST,
  payload: {contractsList}
});
